import { render, staticRenderFns } from "./FoodNicheIcon.vue?vue&type=template&id=4949720d&scoped=true"
import script from "./FoodNicheIcon.vue?vue&type=script&lang=js"
export * from "./FoodNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4949720d",
  null
  
)

export default component.exports